import { z } from "zod"
import { getPasswordValidationMessage } from "@/lib/helpers/password-validation"

export const registerFormSchema = z
  .object({
    firstName: z.string().nonempty("Please enter first name"),
    lastName: z.string().nonempty("Please enter last name"),
    email: z.string().nonempty("Please enter email").email("Invalid email"),
    emailCode: z.string().nonempty("Please enter the code in your email"),
    password: z
      .string()
      .nonempty("Please enter password")
      .superRefine((password, ctx) => {
        const message = getPasswordValidationMessage(password)
        if (message) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message,
          })
        }
      }),
    phone: z
      .string()
      .min(6, "Please enter phone number")
      .regex(/^\+?\d+$/, { message: "Mobile phone must contain digits only" }),
  })

export type RegisterFormData = z.infer<typeof registerFormSchema>
